<template>
  <v-navigation-drawer
    app
    width="287"
    mini-variant-width="88"
    :value="true"
    :mini-variant="expanded"
    @update:mini-variant="$emit('input', $event)"
    class="default__navigation"
    stateless
    :expand-on-hover="expanded"
  >
    <div class="sidebar">
      <div class="navigation">
        <router-link
          :to="{
            name: 'dashboard'
          }"
        >
          <div class="navigation-logo-wrapper">
            <div class="navigation-logo"></div>
          </div>
        </router-link>
        <v-list class="navigation-sidebar" shaped :ripple="false">
          <div v-for="(category, key) in sidebarMenu" :key="key">
            <template v-for="item in filteredCategories(category)">
              <v-list-group
                v-if="item.items"
                :key="item.id"
                :value="$route.meta.group === item.group"
                :prepend-icon="item.action"
                append-icon="icon-arrow-down"
                no-action
                :ripple="false"
                class="navigation-group-item"
                :class="{ 'active-group': $route.meta.group === item.group }"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="$t(`message.menuLabels.${item.module}`)"
                    >
                    </v-list-item-title>
                    <span
                      v-if="
                        item.notifications &&
                          item.notifications.some(key => hasNotification(key))
                      "
                      class="has-notification"
                    />
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="child in item.items"
                  :key="child.id"
                  :to="
                    !child.exact
                      ? `/${getCurrentAppLayoutHandler() + child.path}`
                      : child.path
                  "
                  @click.native="
                    handleListItemClick(
                      !child.exact
                        ? `/${getCurrentAppLayoutHandler() + child.path}`
                        : child.path
                    )
                  "
                  :ripple="false"
                  class="navigation-item"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="$t(`message.menuLabels.${child.module}`)"
                    ></v-list-item-title>
                    <span
                      v-if="
                        child.notifications &&
                          child.notifications.some(key => hasNotification(key))
                      "
                      class="has-notification"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-item
                v-else
                :key="item.id"
                :to="
                  !item.exact
                    ? `/${getCurrentAppLayoutHandler() + item.path}`
                    : item.path
                "
                @click.native="
                  handleListItemClick(
                    !item.exact
                      ? `/${getCurrentAppLayoutHandler() + item.path}`
                      : item.path
                  )
                "
                :ripple="false"
                class="navigation-item"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="$t(`message.menuLabels.${item.module}`)"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </div>
        </v-list>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import { getCurrentAppLayout } from "@/helpers/helpers";
import { hasNotification } from "@/helpers/notifications";
import { isFeatureFlagEnabled } from "@/helpers/posthog";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { FEATURE_FLAG } from "@/helpers/posthog";
import { planRestrictionsCheck } from "@/helpers/plan-restrictions-check";

export default {
  name: "Sidebar",
  model: {
    prop: "show",
    event: "input"
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      expanded: null
    };
  },
  watch: {
    show(value) {
      this.expanded = !value;
    }
  },
  computed: {
    ...mapGetters({
      sidebarMenu: "settings/sidebarMenu"
    })
  },
  methods: {
    planRestrictionsCheck,
    hasNotification,
    isFeatureFlagEnabled,
    handleListItemClick(path) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.NAV_MENU_ITEM_CLICK,
        dest_page_url: path
      });
    },
    getCurrentAppLayoutHandler() {
      return getCurrentAppLayout(this.$router);
    },
    isFeatureFlagEnabledForItem(item) {
      return "featureFlag" in item
        ? isFeatureFlagEnabled(item.featureFlag)
        : true;
    },

    arePlanRestrictionsMetForItem(item) {
      return "planRestrictions" in item
        ? planRestrictionsCheck(item.planRestrictions)
        : true;
    },

    isVisibilityMetForItem(item) {
      return (
        !("visibilityGetter" in item) ||
        this.$store.getters[item.visibilityGetter.path] ===
          item.visibilityGetter.expectedValue ||
        (this.$store.getters[item.visibilityGetter.path] &&
          isFeatureFlagEnabled(FEATURE_FLAG.SHOW_REVIEW_BOOSTER_PROMO) &&
          !isFeatureFlagEnabled(FEATURE_FLAG.SHOW_REVIEW_BOOSTER))
      );
    },

    filterChildItems(items) {
      return items.filter(child => {
        const childPlanRestrictionsMet = this.arePlanRestrictionsMetForItem(
          child
        );
        const childFeatureFlagEnabled = this.isFeatureFlagEnabledForItem(child);
        return childPlanRestrictionsMet && childFeatureFlagEnabled;
      });
    },

    filteredCategories(category) {
      return category.filter(item => {
        const featureFlagEnabled = this.isFeatureFlagEnabledForItem(item);
        const planRestrictionsMet = this.arePlanRestrictionsMetForItem(item);
        const visibilityMet = this.isVisibilityMetForItem(item);

        if (item.items) {
          item.items = this.filterChildItems(item.items);
          return (
            featureFlagEnabled &&
            planRestrictionsMet &&
            visibilityMet &&
            item.items.length > 0
          );
        }

        return featureFlagEnabled && planRestrictionsMet && visibilityMet;
      });
    }
  }
};
</script>
